/* import __COLOCATED_TEMPLATE__ from './multispindle.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();